import { keyFnToComparator } from "@/shared/utils/Comparator.ts";

export type SortKeyType = number | string;

export function sortByKey<ItemType>(
  array: ItemType[],
  keyFn: (a: ItemType) => SortKeyType,
  reversed = false,
): void {
  array.sort(keyFnToComparator(keyFn, reversed));
}

export function range(limit: number, start?: number, step?: number): number[] {
  const res: number[] = [];
  for (let i = start ?? 0; i < limit; i += step ?? 1) {
    res.push(i);
  }
  return res;
}

/**
 * Groups array items in a map based on key function.
 * @param list
 * @param keyFn
 */
export function groupBy<K, V>(list: V[], keyFn: (v: V) => K): Map<K, V[]> {
  const res = new Map<K, V[]>();
  for (const value of list) {
    const key = keyFn(value);
    const targetList = res.get(key);
    if (targetList === undefined) {
      res.set(key, [value]);
    } else {
      targetList.push(value);
    }
  }
  return res;
}

/**
 * Splits array into two arrays based on predicate.
 * (returns true items first)
 * @param list
 * @param predicate
 */
export function partition<V>(
  list: V[],
  predicate: (v: V) => boolean,
): [V[], V[]] {
  const grouped = groupBy(list, predicate);
  return [grouped.get(true) ?? [], grouped.get(false) ?? []];
}

export function isArrayEmpty(list: unknown[] | undefined | null): boolean {
  return list === undefined || list === null || list.length === 0;
}
